import React, { useEffect } from "react"
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { useHistory } from "react-router-dom";
import MsbTableWrapper from "./MsbTableWrapper";


const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Baseline Rules",
        redirectTo: "/msb",
    }
]

function MsbPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Baseline Rules')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes />
            <MsbTableWrapper />
        </>
    );
}


export default withMainLayout(connect()(MsbPage));